import { FC, memo } from 'react';
import { CgTrash } from 'react-icons/cg';
import { Button, Icon } from '@chakra-ui/react';

import { FormRepeaterRemoveButtonProps } from './types/FormRepeaterRemoveButtonProps';

const FormRepeaterRemoveButtonComponent: FC<FormRepeaterRemoveButtonProps> = ({
  onRemove,
}) => (
  <Button onClick={onRemove} px={0} size="lg" type="button" variant="outline">
    <Icon as={CgTrash} boxSize={5} />
  </Button>
);

export const FormRepeaterRemoveButton = memo(FormRepeaterRemoveButtonComponent);
